import Anchor from '../styled-components/Anchor';
import { ParagraphAgreementRequirement } from '../styled-components/ParagraphAgreementRequirement';

import classNames from 'classnames';
import { ReactElement, useContext } from 'react';
import { useTranslation } from '@digitaltitransversal/cronos/i18n';
import './index.scss';
import { CheckoutFrameContext } from 'app/context/CheckoutFrameContext';
import { sendAnalytic } from 'app/util/analytics';
import { AnalyticEvents } from 'app/util/constants';

const T_ROOT = 'agreementsAcceptanceRequirement.privacyPolicy';

export const AgreementContentPrivacyPolicy = () => {
  const { t } = useTranslation();
  const { checkoutRequest } = useContext(CheckoutFrameContext);
  const { id, companyId, type } = checkoutRequest;

  const urlPrivacyPolicy = 'https://www.spinnegocios.com/avisodeprivacidad-oxxopay';
  const firstText = t(`${T_ROOT}.first`);

  const secondText: ReactElement<HTMLAnchorElement> = (
    <Anchor
      href={urlPrivacyPolicy}
      target='_blank'
      onClick={() => sendAnalytic(AnalyticEvents.termsAndConditions, id, companyId, type)}
    >
      {t(`${T_ROOT}.second`)}
    </Anchor>
  );
  const thirdText = t(`${T_ROOT}.third`);

  return (
    <ParagraphAgreementRequirement className={classNames('AgreementContentPrivacyPolicy', classNames)}>
      {firstText}
      {secondText}
      {thirdText}
    </ParagraphAgreementRequirement>
  );
};
